import {Container, Nav, Navbar, NavItem, NavLink} from "react-bootstrap";
import Logout from "./Logout";
import {useNavigate} from "react-router-dom";

const Index:React.FC = () => {
    let navigate = useNavigate();

    return <Navbar bg="light" expand="lg">
        <Container>
            <Navbar.Brand>VAP Supplier Portal</Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-auto" defaultActiveKey="activations">
                    <NavLink eventKey="activations" onClick={() => {navigate("/")}} >Activations</NavLink>
                    <a className="nav-link" href="https://reports.signio.co.za/gu_signiobi/" target="_blank">Reports</a>
                </Nav>
                <Nav>
                    <NavItem>
                        <Logout />
                    </NavItem>
                </Nav>
            </Navbar.Collapse>
        </Container>
    </Navbar>;
}

export default Index;